<script>
  import appConfig from "@/app.config";
  import axios from 'axios';
  import Layout from "@/layouts/main";
  import Navbar from "@/components/navbar";
  //import Scrollspy from 'vue2-scrollspy';
  //import AOS from 'aos';
  //import 'aos/dist/aos.css'; 
  //import { EventBus } from "@/event-bus";
  
  export default {
    components: {
      Layout,
      Navbar,
    },
    data() {
      return {
        login: {
          idx: 0,
          level: 0,
          nick: "",
          isLogin: false,
        },
        baseInfo: {},
        editPage: false, // 관리자 편집 기능 사용 유무
        textData: [],
      }
    },
    computed: {
    },
    metaInfo() {
      return {
        title: '개인정보 처리방침 | 대구여성인권센터',
        meta: [
          {
            name: 'description',
            content: '대구여성인권센터 개인정보 처리방침입니다.'
          },
          {
            property: 'og:title',
            content: '개인정보 처리방침 | 대구여성인권센터'
          },
          {
            property: 'og:description',
            content: '대구여성인권센터 개인정보 처리방침입니다.'
          },
          {
            property: 'og:url',
            content: window.location.href
          },
          {
            name: 'twitter:title',
            content: '개인정보 처리방침 | 대구여성인권센터'
          },
          {
            name: 'twitter:description',
            content: '대구여성인권센터 개인정보 처리방침입니다.'
          }
        ]
      }
    },
    mounted() {
    },
    created() {
      this.first()
    },
    methods: {
      // 홈페이지 기본정보
      first() {
        // 로그인 사용자 정보
        let getLocalStorage = JSON.parse(localStorage.getItem('user'))
        if (getLocalStorage) {
          this.login.idx = getLocalStorage.idx
          this.login.nick = getLocalStorage.nick
          this.login.level = getLocalStorage.level
          this.token = getLocalStorage.token
        }
        this.baseInfo = this.$store.getters.getWebSiteInfoBase
        this.getTextData()
      },
      textDataEdit() {
        this.editPage = true
        // br 태그를 \n 태그로 변경 해주자
        this.textData.text1 = this.textData.text1.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text2 = this.textData.text2.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text3 = this.textData.text3.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text4 = this.textData.text4.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text5 = this.textData.text5.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text6 = this.textData.text6.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text7 = this.textData.text7.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text8 = this.textData.text8.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text9 = this.textData.text9.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text10 = this.textData.text10.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text11 = this.textData.text11.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text12 = this.textData.text12.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text13 = this.textData.text13.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text14 = this.textData.text14.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text15 = this.textData.text15.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text16 = this.textData.text16.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text17 = this.textData.text17.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text18 = this.textData.text18.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text19 = this.textData.text19.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text20 = this.textData.text20.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text21 = this.textData.text21.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text22 = this.textData.text22.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text23 = this.textData.text23.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text24 = this.textData.text24.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text25 = this.textData.text25.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text26 = this.textData.text26.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text27 = this.textData.text27.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text28 = this.textData.text28.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text29 = this.textData.text29.replace(/<br\s*\/?>/gi, '\n')
        this.textData.text30 = this.textData.text30.replace(/<br\s*\/?>/gi, '\n')
      },
      textDataEditCancelButton() {
        this.editPage = false
        // \n 태그를 br 태그로 변경 해주자
        this.textData.text1 = this.textData.text1.replace(/\n/gi, '<br />')
        this.textData.text2 = this.textData.text2.replace(/\n/gi, '<br />')
        this.textData.text3 = this.textData.text3.replace(/\n/gi, '<br />')
        this.textData.text4 = this.textData.text4.replace(/\n/gi, '<br />')
        this.textData.text5 = this.textData.text5.replace(/\n/gi, '<br />')
        this.textData.text6 = this.textData.text6.replace(/\n/gi, '<br />')
        this.textData.text7 = this.textData.text7.replace(/\n/gi, '<br />')
        this.textData.text8 = this.textData.text8.replace(/\n/gi, '<br />')
        this.textData.text9 = this.textData.text9.replace(/\n/gi, '<br />')
        this.textData.text10 = this.textData.text10.replace(/\n/gi, '<br />')
        this.textData.text11 = this.textData.text11.replace(/\n/gi, '<br />')
        this.textData.text12 = this.textData.text12.replace(/\n/gi, '<br />')
        this.textData.text13 = this.textData.text13.replace(/\n/gi, '<br />')
        this.textData.text14 = this.textData.text14.replace(/\n/gi, '<br />')
        this.textData.text15 = this.textData.text15.replace(/\n/gi, '<br />')
        this.textData.text16 = this.textData.text16.replace(/\n/gi, '<br />')
        this.textData.text17 = this.textData.text17.replace(/\n/gi, '<br />')
        this.textData.text18 = this.textData.text18.replace(/\n/gi, '<br />')
        this.textData.text19 = this.textData.text19.replace(/\n/gi, '<br />')
        this.textData.text20 = this.textData.text20.replace(/\n/gi, '<br />')
        this.textData.text21 = this.textData.text21.replace(/\n/gi, '<br />')
        this.textData.text22 = this.textData.text22.replace(/\n/gi, '<br />')
        this.textData.text23 = this.textData.text23.replace(/\n/gi, '<br />')
        this.textData.text24 = this.textData.text24.replace(/\n/gi, '<br />')
        this.textData.text25 = this.textData.text25.replace(/\n/gi, '<br />')
        this.textData.text26 = this.textData.text26.replace(/\n/gi, '<br />')
        this.textData.text27 = this.textData.text27.replace(/\n/gi, '<br />')
        this.textData.text28 = this.textData.text28.replace(/\n/gi, '<br />')
        this.textData.text29 = this.textData.text29.replace(/\n/gi, '<br />')
        this.textData.text30 = this.textData.text30.replace(/\n/gi, '<br />')
      },
      // 백엔드에서 개인정보처리방침 가져오기
      getTextData() {
        axios({
          method: 'POST',
          url: appConfig.fastapi + '/board/jy_privacy_policy_get',
          data: {
            "work": "privacy",
          },
        })
        .then((response) => {
          if (response.data.textData) {
            this.textData = response.data.textData
          } else {
            this.$notify({ type: 'success', duration:2000, 'title': '실패', text: response.data.message})
          }
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
        })
      },
      // 개인정보처리방침 저장
      textDataSaveButton(workKey) {
        axios({
          method: 'POST',
          url: appConfig.fastapi + '/board/jy_privacy_policy_edit_save',
          data: {
            "workKey": workKey,
            "value": this.textData[workKey].replace(/\n/gi, '<br />'),
          },
        })
        .then((response) => {
          this.$notify({ type: 'success', duration:2000, 'title': '성공', text: response.data.message})
        })
        .catch((error) => {
          this.$notify({ type: 'danger', duration:2000, 'title': '실패', text: error.response.data.message})
        })
        .finally(() => {
          this.getTextData()
          this.editPage = false
        })
      },
    },
  }
  </script>
  
  <template>
    <Layout>
      <!-- 네비게이션 글자 하얗게는 :nav-light="true" -->
      <Navbar :nav-light="true" />
  
      <section class="bg-half-2 navwave d-table w-100">
        <div class="animation-effect-8"><i class="mdi mdi-cloud-outline effect-icon-1 text-primary"></i></div>
        <div class="animation-effect-9"><i class="mdi mdi-rocket effect-icon-1 text-light"></i></div>
        <div class="bread-overlay-2 opacity-5"></div>
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-12 text-center">
              <div class="page-next-level">
                <div class="title text-white title-dark">
                  <h3>개인정보 처리방침</h3>
                </div>
                <div class="page-next">
                  <nav aria-label="breadcrumb" class="d-inline-block">
                    <ul class="breadcrumb bg-white rounded shadow mb-0">
                      <li class="breadcrumb-item">
                        <router-link to="/">홈</router-link>
                      </li>
                      <li class="breadcrumb-item active" aria-current="page">개인정보 처리방침</li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  
      <!-- 둥글게 처리 -->
      <div class="position-relative">
        <div class="shape overflow-hidden text-white">
          <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
          </svg>
        </div>
      </div>
  
      <section class="mb-0">
        <div class="container">
          <div class="row align-items-center">
            
          </div>
        </div>

      </section>

      <section class="bg-light border-top mb-0 py-5">
        <div class="container">

          <!-- 관리자라면 -->
          <div v-if="login.level > 97 && !editPage" class="mb-4">
            <b-button @click="textDataEdit()" class="btn btn-block btn-md btn-soft-blue">
              <i class="mdi mdi-book-edit mr-1"></i>관리자 편집하기
            </b-button>
          </div>
          <!-- 관리자 편집 페이지 -->
          <div v-if="login.level > 97 && editPage" class="mb-4">
            <b-button @click="textDataEditCancelButton()" class="btn btn-block btn-md btn-primary">
              <i class="mdi mdi-close mr-1"></i>편집 닫기
            </b-button>
          </div>
          
          <div class="row">

            <div class="col-lg-12 col-md-12 mt-sm-12 pt-sm-0">
              <div class="section-title">
                <!-- text1-->
                <div v-if="editPage == false && textData.text1" class="text-muted mb-4" v-html="textData.text1"></div>
                <div v-if="editPage == true" class="text-muted mb-4">
                  <b-form-textarea v-model="textData.text1" rows="2"  class="form-control input-square" placeholder="2줄 이내 권장합니다." maxlength="1000" />
                  <b-button @click="textDataSaveButton('text1')" class="btn btn-blue btn-square btn-sm btn-block">저장하기</b-button>
                </div>
              </div>
            </div>
            
            <div class="col-lg-12">
              <div class="section-title text-center mb-5">
                <span class="badge badge-pill badge-secondary mb-2">
                  <i class="mdi mdi-shield-key-outline h3"></i>
                </span>
                <!-- text2-->
                <div v-if="editPage == false && textData.text2" class="h4 title mb-2" v-html="textData.text2"></div>
                <div v-if="editPage == true" class="h4 title mb-2">
                  <b-form-textarea v-model="textData.text2" rows="2"  class="form-control input-square" placeholder="1줄 이내 권장합니다." maxlength="100" />
                  <b-button @click="textDataSaveButton('text2')" class="btn btn-blue btn-square btn-sm btn-block">저장하기</b-button>
                </div>
              </div>
            </div>
          </div>
          
          <div class="row">
            <!-- text3&4 ~ text29&30 까지를 카드로 반복 출력 -->
            <div
              v-for="n in 16"
              :key="n"
              class="col-lg-12"
              v-if="editPage || textData['text' + (2 * n + 1)] || textData['text' + (2 * n + 2)]"
            >
              <div class="card mb-4">
                <div class="card-header">
                  <!-- 제목 영역: text3, text5, ... text29 -->
                  <div
                    v-if="editPage === false && textData['text' + (2 * n + 1)]"
                    class="h5 mb-0"
                    v-html="textData['text' + (2 * n + 1)]"
                  ></div>
                  <div
                    v-else-if="editPage === true"
                    class="h5 mb-0"
                  >
                    <b-form-textarea
                      v-model="textData['text' + (2 * n + 1)]"
                      rows="1"
                      class="form-control form-control-sm input-square"
                      placeholder="제목 한줄 권장합니다."
                      maxlength="100"
                    />
                    <b-button
                      @click="textDataSaveButton('text' + (2 * n + 1))"
                      class="btn btn-blue btn-square btn-sm btn-block"
                    >
                      저장하기
                    </b-button>
                  </div>
                  <!-- 관리자라면 편집 버튼 -->
                  <div v-if="login.level > 97 && !editPage" class="m-0">
                    <b-button @click="textDataEdit()" class="btn btn-square btn-sm btn-soft-blue">
                      <i class="mdi mdi-pencil mr-1"></i>편집하기
                    </b-button>
                  </div>
                </div>
                <div class="card-body">
                  <!-- 내용 영역: text4, text6, ... text30 -->
                  <div
                    v-if="editPage === false && textData['text' + (2 * n + 2)]"
                    class="mb-0"
                    v-html="textData['text' + (2 * n + 2)]"
                  ></div>
                  <div
                    v-else-if="editPage === true"
                    class="mb-0"
                  >
                    <b-form-textarea
                      v-model="textData['text' + (2 * n + 2)]"
                      rows="6"
                      class="form-control form-control-sm input-square"
                      placeholder="내용 여러줄 가능합니다."
                      maxlength="1000"
                    />
                    <b-button
                      @click="textDataSaveButton('text' + (2 * n + 2))"
                      class="btn btn-blue btn-square btn-sm btn-block"
                    >
                      저장하기
                    </b-button>
                  </div>
                  <!-- 관리자라면 편집 버튼 -->
                  <div v-if="login.level > 97 && !editPage" class="m-0">
                    <b-button @click="textDataEdit()" class="btn btn-square btn-sm btn-soft-blue">
                      <i class="mdi mdi-pencil mr-1"></i>편집하기
                    </b-button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </Layout>
  </template>